<template>
    <BaseForm>
        <template #fields>
            <MultiLinkGroup>
                <MultiLink
                    :label="$t('external-data')"
                    :links="values.externalData"
                    :error-messages="errors.externalData"
                    @input="setFieldValue('externalData', $event)"
                    @delete="setFieldValue('externalData', $event)"
                />
                <MultiLink
                    :label="$t('internal-data')"
                    :links="values.internalData"
                    :error-messages="errors.internalData"
                    @input="setFieldValue('internalData', $event)"
                    @delete="setFieldValue('internalData', $event)"
                />
            </MultiLinkGroup>
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import MultiLinkGroup from '@/components/MultiLink/MultiLinkGroup.vue';
import { useEventInjection } from '@/event/composables/useEventInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventDataSchema } from '../schemas';

const { event, createEventMultiLink } = useEventInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventMultiLink);

const externalDataId = computed(() => event.value?.externalData?.id);
const internalDataId = computed(() => event.value?.internalData?.id);

const externalDataLinks = computed(() => event.value?.externalData?.links.nodes ?? []);
const internalDataLinks = computed(() => event.value?.internalData?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventDataSchema,
    computed(() => ({
        externalData: getFormFieldLinks(externalDataLinks),
        internalData: getFormFieldLinks(internalDataLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: externalDataId.value, fieldName: 'externalData', links: values.value.externalData },
            { id: internalDataId.value, fieldName: 'internalData', links: values.value.internalData },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
